<template>
  <div v-loading="isLoading">
    <grid
      ref="grid"
      :config="config"
      @onGet="handlerGetData"
      @onChangeLoading="handlerChangeLoading"
      class="no-grid-border"
    />
    <editor
      v-if="!disabled"
      :dataRFQ="data"
      :config="{id: config.id, api: 'RFQ1s/Get/'}"
      :list="listRFQ1"
    />
  </div>
</template>

<script>
import config from './GridConfig'
import { waitValue } from '@/utils/promises.js'
export default {
  name: 'RFQAddPartsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Shared' */ './Editor')
  },
  props: {
    disabled: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
    data: { type: Object, required: true },
    isValid: { type: Boolean },
    eventID: { type: String, required: true }
  },
  watch: {
    'data.rfqid': {
      immediate: true,
      handler (value) {
        this.getGrid()
          .then((grid) => {
            if (!this.data.rfqid) return
            let filters = `rfqid == "${this.data.rfqid}"`
            grid.model.store.get.filters = filters
            grid.loadData()
          })
      }
    }
  },
  data () {
    let payload = {
      rowControls: {
        right: {
          controls: [
            // eslint-disable-next-line
            { type: 'delete', disabled: this.checkDisable, permission: 'isAllowToEditRFQs' }
          ]
        }
      },
      mode: {
        isPreviewMode: !!this.disabled
      }
    }
    return {
      isLoading: false,
      config: this.$_.merge(config, payload)
    }
  },
  computed: {
    listRFQ1 () {
      return this.$store.state[this.moduleName].listRFQ1
    },
    mapListRFQ3 () {
      return this.$store.getters[`${this.moduleName}/mapListRFQ3`]
    }
  },
  methods: {
    checkDisable (data, root) {
      return !!this.mapListRFQ3[data.rfqid + '__' + data.partID]
    },
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    /**
     * @desc Update list of RFQ1
     * @param dataList {Array} - list of data (response)
     */
    handlerGetData (dataList) {
      this.$store.commit(`${this.moduleName}/SET`, { key: 'listRFQ1', value: dataList })
      this.$emit('update:isValid', !!dataList.length)
      this.$emit('command', 'came-list-rfq-1')
    },
    handlerChangeLoading (value) {
      this.isLoading = value
    }
  }
}
</script>
<style lang="stylus">
  .rfq-add-parts{
    &.grid-side .grid-wrapper .grid-table table .left-fixed-shadow:before{
      display none
    }
    h1{
      color #09729b
      font-weight bold
      text-transform uppercase
      font-size 2.3rem
      line-height 1.2
      margin: 0 0 1.6rem
    }
    &.grid-side .grid-wrapper{
      overflow unset
      .scroll-area{
        position relative
        min-height 15rem
      }
      .grid-table{
        min-height 15rem
        margin 0
        overflow unset
      }
    }
    .grid-table table{
      position static
    }
    .no-data{
      top 5rem
    }
  }
</style>
